// ─── OWNER CONFIGURATION ──────────────────────────────────────────────
// Update these values anytime. All WhatsApp / call / social / map links
// across the entire website are generated from this single file.

export const CONFIG = {
  name: "Hyderabad Shopping Mall",
  tagline: "Fashion for every occasion.",
  address: "Hyderabad Road, Bafna, Near Baba Petrol Pump, Nanded, Maharashtra – 431604",
  whatsapp: "919908366736", // WhatsApp number with country code, digits only
  phone: "+918983466736", // tap-to-call number
  phoneDisplay: "89834 66736",
  hoursDisplay: "11:00 AM – 10:00 PM · Open all 7 days",
  openingHoursSchema: "Mo-Su 11:00-22:00",
  instagram: "https://www.instagram.com/hyderabadshoppingmall_",
  mapUrl: "https://maps.app.goo.gl/YnVEUvwHw5yZ5acNA", // verified Google Business Profile listing
  mapEmbed: "https://www.google.com/maps?cid=8859096362666727167&output=embed",
  // FESTIVAL CAMPAIGN — switch on/off per festival. Set enabled: false to hide.
  announcementText: "DIWALI & WEDDING SEASON OFFERS ARE LIVE",
  heroBadge: "FESTIVE SPECIAL",
  festivalBanner: {
    enabled: true,
    image: "/assets/festival-diwali.jpeg",
    alt: "Diwali and Wedding Season special offers at Hyderabad Shopping Mall — Sarees 25-40% off, Kurtis buy 2 get 1 free, Kids Wear 30% off",
    link: "/offers",
  },
  // DELIVERY RULES (owner-approved): pickup & Nanded local free, courier ₹100, free above ₹4000
  deliveryCharges: { pickup: 0, local: 0, courier: 100 },
  courierFreeAbove: 4000,
  // OWNER ASSETS — real Hyderabad Shopping Mall media
  logo: "/assets/logo.jpeg", // actual Hyderabad Shopping Mall logo
  buildingPhoto: "/assets/building.jpeg", // actual building exterior photograph
  storePhotos: [
    // real owner-provided store photographs
    "/assets/entrance.jpeg", // entrance with Hyderabad Shopping Mall signage
    "/assets/lehenga-display.jpeg", // lehenga & bridal display
    "/assets/suits-display.jpeg", // suits mannequin display
    "/assets/interior-wide.jpeg", // full showroom floor
  ],
  // ANALYTICS — paste real IDs to activate (leave blank to keep disabled)
  gaId: "G-VT7Y5TN6X8", // GA4 Measurement ID — active
  metaPixelId: "4008452979370202", // Meta Pixel ID — active
};

// Builds a WhatsApp deep link with a pre-filled, context-aware message.
export const waLink = (context) =>
  `https://wa.me/${CONFIG.whatsapp}?text=${encodeURIComponent(
    `Hello Hyderabad Shopping Mall, I am interested in your ${context || "collections"}. Please share more details.`
  )}`;

// Analytics events are sent via src/lib/analytics.js (activates only when
// real GA4 / Meta Pixel IDs are set in CONFIG above).

// ─── CONTENT DATA ──────────────────────────────────────────────────────

export const IMAGES = {
  sarees: "https://images.unsplash.com/photo-1610030469983-98e550d6193c?auto=format&fit=crop&w=900&q=85",
  kurtis: "https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?auto=format&fit=crop&w=900&q=85",
  suits: "https://images.unsplash.com/photo-1585487000160-6ebcfceb0d03?auto=format&fit=crop&w=900&q=85",
  party: "https://images.unsplash.com/photo-1610048869310-d889ff25c374?auto=format&fit=crop&w=900&q=85",
  wedding: "https://images.unsplash.com/photo-1571908599407-cdb918ed83bf?auto=format&fit=crop&w=1600&q=85",
  kids: "https://images.unsplash.com/photo-1622290291468-a28f7a7dc6a8?auto=format&fit=crop&w=900&q=85",
  western: "https://images.unsplash.com/photo-1496747611176-843222e1e57c?auto=format&fit=crop&w=900&q=85",
};

export const CATEGORIES = [
  { name: "Sarees", sub: "Traditional to Contemporary", image: "/assets/sarees-display.jpeg", slug: "sarees" },
  { name: "Kurtis", sub: "Everyday to Elegant", image: "/assets/kurtis-section.webp", slug: "kurtis" },
  { name: "Unstitched Suits", sub: "Pure Cotton & Party Wear", image: "/assets/suits-display.jpeg", slug: "unstitched-suits" },
  { name: "Party Wear", sub: "Make Every Celebration Special", image: "/assets/party-wear.jpeg", slug: "party-wear" },
  { name: "Kids Wear", sub: "Fashion for Little Stars", image: "/assets/kids-wear.jpeg", slug: "kids-wear" },
  { name: "Western Collection", sub: "Modern Everyday Style", image: IMAGES.western, slug: "western-collection" },
];

// Only owner-approved offers are listed here. Do not add unverified offers.
export const OFFERS = [
  { title: "Sarees", detail: "25% – 40% OFF" },
  { title: "Kurtis", detail: "Buy 2 Get 1 Free" },
  { title: "Kids Wear", detail: "30% OFF" },
  { title: "Palazzo", detail: "10% OFF" },
  { title: "Pure Cotton Unstitched Suits", detail: "Starting from ₹500" },
  { title: "Party Wear Unstitched Suits", detail: "Special Discounts" },
];

export const NAV_LINKS = [
  ["Home", "/"],
  ["Collections", "/collections"],
  ["Offers", "/offers"],
  ["Wedding", "/collections/wedding"],
  ["New Arrivals", "/new-arrivals"],
  ["About", "/about"],
  ["Contact", "/contact"],
];
